module.exports = __webpack_public_path__ + "img/swing_right_door.4bd40785.png";